import { TStatus } from "utils/InterfaceAndTypeGeneral";
import { messages } from "./constants";

interface IMessage {
  typeStatus: TStatus;
}

const Messsages = ({ typeStatus }: IMessage) => {
  return (
    <>
      {messages[typeStatus]?.map((msg, index: number) => (
        <li
          key={msg.id}
          className={`leading-snug ${index === 0 ? "mb-1" : ""}`}
        >
          {msg.text}
          {msg.highlight && <span className="font-bold">{msg.highlight}</span>}
          {msg.continuation}
        </li>
      ))}
    </>
  );
};
export default Messsages;
